import axios from '@/utils/request'
import qs from 'qs'

const request = {
    getInit(params) {
        return axios.post('/api/rank/init', qs.stringify(params))
    }
}

export default request
